"use client";

import { Badge } from "@/components/ui/badge";
import { siteConfig } from "@/lib/siteConfig";
import { GridSvg } from "@/components/gridSvg";

export default function Values() {
  return (
    <section className={"wrapper py-10 relative"}>
      <GridSvg />
      <div className={"flex flex-col gap-5 items-center text-center"}>
        <Badge>Our Values</Badge>
        <h1 className={"text-4xl font-bold "}>
          Principles That{" "}
          <span className={"text-primary"}>Drive Us Forward</span>
        </h1>
        <p className={"text-muted-foreground text-lg font-semibold"}>
          Our core values shape every decision we make and every relationship we
          build.
        </p>
        <div
          className={
            "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-5"
          }
        >
          {siteConfig.values.map((value, index) => (
            <div
              key={index}
              className={
                " flex flex-col items-center gap-2 text-center square-gradient-bg py-10 px-4 rounded"
              }
            >
              <span className={"text-white bg-primary p-5  rounded-full"}>
                <value.icon />
              </span>
              <h1 className={"text-primary text-xl font-bold"}>
                {value.title}
              </h1>
              <p className={"text-sm font-semibold text-accent-foreground"}>
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
